import React, { useState } from 'react';
import styled from 'styled-components';
import { getIn } from 'seamless-immutable';
import BuyBox from '@catalogo/ui-americanas-mobile-buybox';
import OutOfStockDisclaimer from '@catalogo/ui-americanas-mobile-out-of-stock-disclaimer';
import NearStore from '@catalogo/ui-americanas-mobile-near-store';
import OffersBox from '@catalogo/ui-americanas-mobile-offers-box';
import BuyTogetherVip from '@catalogo/ui-americanas-mobile-buy-together-vip';
import Freight from '@catalogo/ui-americanas-mobile-freight/';
import { withDiscountProgressiveExperiment } from '@catalogo/service-americanas-product/src/hocs/discount-progressive-expetiment';
import SelectorQuantity from './selector-quantity';
import { getLimit, showSelector } from './helpers';

const hasOffers = value => !!getIn(value, ['offers', 'result'], []).length;

const ProductOffer = props => {
  const renderDeliveryMode = () => {
    const { currentSku, product } = props;
    const isO2O = getIn(currentSku, ['offers', 'result', 0, 'seller', 'id']) === '33014556000196';
    const isDigital = getIn(product, ['isDigital']);

    if (!hasOffers(currentSku) || isDigital) {
      return null;
    }

    return <div>{isO2O ? <NearStore {...props} /> : <Freight {...props} />}</div>;
  };

  const [selectQuantityWasUsed, setSelectQuantityWasUsed] = useState(false);
  const { currentSku, recData, product, page, history, experiment } = props;
  const BuyTogetherVipShelf = getIn(recData, ['item_page.combo_vip']);
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const { salesPrice, quantity } = offer ?? {};
  const limit = getLimit(quantity);
  const showUISelector = hasOffers(currentSku) && showSelector(salesPrice, limit);

  return (
    <>
      <div>{!hasOffers(currentSku) && <OutOfStockDisclaimer {...props} />}</div>
      <div>
        {hasOffers(currentSku) && (
          <Wrapper>
            <BuyTogetherVip shelf={BuyTogetherVipShelf} {...props} />
          </Wrapper>
        )}
      </div>
      <div>
        {hasOffers(currentSku) && (
          <BuyBox
            product={product}
            page={page}
            currentSku={currentSku}
            history={history}
            discountProgressiveExperiment={props?.discountProgressiveExperiment}
            variantB
          />
        )}
      </div>
      {renderDeliveryMode()}
      {showUISelector && (
        <SelectorQuantity history={history} limit={limit} setSelectQuantityWasUsed={setSelectQuantityWasUsed} />
      )}
      <div>
        <OffersBox
          hasOffers={hasOffers(currentSku)}
          {...props}
          experiment={experiment}
          variantB
          selectQuantityWasUsed={selectQuantityWasUsed}
        />
      </div>
    </>
  );
};

const Wrapper = styled.div`
  padding: 10px;
`;

export default withDiscountProgressiveExperiment(ProductOffer);
